import React, { createContext, useContext, useState, ReactNode } from 'react';
import ComingSoonModal from './ComingSoonModal';

interface ComingSoonContextType {
  openModal: () => void;
  closeModal: () => void;
  isOpen: boolean;
}

const ComingSoonContext = createContext<ComingSoonContextType | undefined>(undefined);

export const useComingSoon = () => {
  const context = useContext(ComingSoonContext);
  if (context === undefined) {
    throw new Error('useComingSoon must be used within a ComingSoonProvider');
  }
  return context;
};

interface ComingSoonProviderProps {
  children: ReactNode;
}

export const ComingSoonProvider: React.FC<ComingSoonProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <ComingSoonContext.Provider value={{ openModal, closeModal, isOpen }}>
      {children}
      <ComingSoonModal isOpen={isOpen} onClose={closeModal} />
    </ComingSoonContext.Provider>
  );
}; 